export const setEmailOtpResendCount = (count) => {
    localStorage.setItem("emailOtpResendCount", JSON.stringify(count));
}

export const getEmailOtpResendCount = () => {
    const emailOtpResendCount = JSON.parse(localStorage.getItem("emailOtpResendCount"));
    return emailOtpResendCount;
}

export const removeEmailOtpResendCount = () => {
    localStorage.removeItem("emailOtpResendCount");
};